import {Iroute} from "./index.type";

export const routesTechnologiesMap: Iroute[] = [
  {
    page: "kartaTechnologies",
    title: "Карта технологий",
    disabled: false,
  },
  {
    page: "esg",
    title: "ESG",
    disabled: false,
  },
  {
    page: "finTech",
    title: "FinTech - Тренды",
    disabled: false,
  },
  {
    page: "weakSignals",
    title: "FinTech - Слабые сигналы",
    disabled: false,
  },
  {
    page: "state_initiative",
    title: "ЦРГЦИ - Инициативы",
    disabled: false,
  },
  {
    page: "crgci_organizations",
    title: "ЦРГЦИ - Организации",
    disabled: false,
  },
];
